import React, { useState } from 'react';
import { motion } from 'framer-motion';
import LetterForm from './components/LetterForm';
import PDFPreview from './components/PDFPreview';
import Header from './components/Header';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    language: 'spanish',
    date: new Date().toISOString().split('T')[0],
    recipientName: '',
    office: '',
    city: '',
    agentName: '',
    agentTitle: '',
    additionalNotes: ''
  });

  const [showPreview, setShowPreview] = useState(false);

  const handleFormSubmit = (data) => {
    setFormData(data);
    setShowPreview(true);
  };

  const handleBackToForm = () => {
    setShowPreview(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Header />
      
      <main className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          {!showPreview ? (
            <LetterForm onSubmit={handleFormSubmit} initialData={formData} />
          ) : (
            <PDFPreview 
              formData={formData} 
              onBack={handleBackToForm}
              onEdit={() => setShowPreview(false)}
            />
          )}
        </motion.div>
      </main>
    </div>
  );
}

export default App;